var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Help"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("下载客户端")])])]),_c('div',{staticClass:"Help-box"},[_c('div',{staticClass:"Help-content"})])])
}]

export { render, staticRenderFns }